import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Register from '../components/Register.vue'
import ChatWindow from '../components/ChatWindow.vue'
import MobileChat from '../components/MobileChat.vue'
import KnowledgeBaseLayout from '../components/KnowledgeBaseLayout.vue'
import UserManagement from '../components/UserManagement.vue'
import Favorites from '../components/Favorites.vue'
import RelatedQuestionManagement from '../components/RelatedQuestionManagement.vue'
import HistoryConversations from '../components/HistoryConversations.vue'
import FeedbackModule from '../components/FeedbackModule.vue'

Vue.use(VueRouter)

// 检测是否为移动设备
function isMobileDevice() {
  return (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) || window.innerWidth <= 768; // 同时也可以根据屏幕宽度判断
}

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/chat',
    name: 'Chat',
    component: ChatWindow,
    meta: { requiresAuth: true }
  },
  {
    path: '/knowledge',
    name: 'KnowledgeBase',
    component: KnowledgeBaseLayout,
    meta: { requiresAuth: true, requiresKnowledgeAccess: true }
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: UserManagement,
    meta: { requiresAuth: true, requiresUserManagement: true }
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: Favorites,
    meta: { requiresAuth: true }
  },
  {
    path: '/related-questions',
    name: 'RelatedQuestionManagement',
    component: RelatedQuestionManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/history-conversations',
    name: 'HistoryConversations',
    // 隐藏历史记录模块：保留路由占位但重定向至聊天页
    component: HistoryConversations,
    meta: { requiresAuth: true, hidden: true }
  },
  {
    path: '/feedback',
    name: 'FeedbackModule',
    component: FeedbackModule,
    meta: { requiresAuth: true }
  },
  {
    path: '/mobileChat',
    name: 'MobileChat',
    component: MobileChat,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  // 检查是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token')
    if (!token) {
      next('/login')
    } else {
      // 检查是否需要管理员权限
      if (to.matched.some(record => record.meta.requiresAdmin)) {
        const userRole = localStorage.getItem('userRole')
        if (userRole !== 'admin') {
          next('/chat') // 非管理员重定向到聊天页面
        } else {
          next()
        }
      } else if (to.matched.some(record => record.meta.requiresUserManagement)) {
        const userRole = localStorage.getItem('userRole')
        if (userRole !== 'admin' && userRole !== 'user_manager') {
          next('/chat') // 非管理员和用户管理员重定向到聊天页面
        } else {
          next()
        }
      } else if (to.matched.some(record => record.path === '/history-conversations')) {
        // 历史记录模块隐藏：访问时重定向到聊天页
        next('/chat')
      } else if (to.matched.some(record => record.meta.requiresKnowledgeAccess)) {
        // 检查知识库访问权限
        const userRole = localStorage.getItem('userRole')
        if (userRole === 'admin') {
          // 管理员默认有权限
          next()
        } else {
          // 普通用户需要检查权限
          try {
            const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/api/auth/current-user`, {
              headers: {
                'Authorization': token
              }
            })
            
            if (response.ok) {
              const result = await response.json()
              if (result.code === 200 && result.data && result.data.knowledgeAccess) {
                next()
              } else {
                next('/chat') // 无权限重定向到聊天页面
              }
            } else {
              next('/chat')
            }
          } catch (error) {
            console.error('检查知识库权限失败:', error)
            next('/chat')
          }
        }
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router